import { produce } from 'immer'
import {
  GET_BILL_PAY_CARDS_ACTIVE_SOURCE_USER_OR_VIEWER_OR_DELEGATE_USER_ME_COUNT_STATISTICS_SUCCESS,
  GET_BILL_PAY_CARDS_CARDHOLDER_OR_VIEWER_ME_ACTIVE_AND_INACTIVE_COUNT_STATISTICS_SUCCESS,
  GET_BILL_PAY_CARDS_PENDING_REQUESTS_COUNT_STATISTICS_SUCCESS,
  GET_BUDGETS_USER_ME_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_BALANCE_LOCK_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_DELEGATE_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_DIRECT_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_RECURRENCE_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_BALANCE_LOCK_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_BUDGETS_ENABLED_CAN_ISSUE_BUDGETS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_DIRECT_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_RECURRENCE_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_SOURCE_STANDARD_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_ACTIVE_STANDARD_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_DELEGATE_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_DELEGATE_OWNER_ME_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_PENDING_SOURCE_NEED_CARDHOLDER_VERIFICATION_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_PENDING_SOURCE_USER_ME_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_PENDING_SOURCE_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_SOURCE_BUDGETS_ENABLED_CAN_ISSUE_BUDGETS_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_SOURCE_BUDGETS_ENABLED_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_SOURCE_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_SOURCE_USER_OR_VIEWER_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_TIMED_OUT_SOURCE_COUNT_STATISTICS_SUCCESS,
  GET_CREDIT_CARDS_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS,
  GET_GUEST_VIRTUAL_CARDS_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_ACTIVE_OR_PENDING_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_ACTIVE_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_ACTIVE_SOURCE_USER_OR_VIEWER_OR_DELEGATE_USER_ME_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_CARDHOLDER_OR_VIEWER_ME_ACTIVE_AND_INACTIVE_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_CARDHOLDER_PENDING_REQUEST_OR_APPROVER_RULE_APPROVAL_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_INACTIVE_RECIPIENT_ME_ISSUED_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_PENDING_REQUEST_CARDHOLDER_ME_COUNT_STATISTICS_SUCCESS,
  GET_VIRTUAL_CARDS_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS,
  GetBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsSuccessAction,
  GetBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsSuccessAction,
  GetBillPayCardsPendingRequestsCountStatisticsSuccessAction,
  GetBudgetsUserMeCountStatisticsSuccessAction,
  GetCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveDelegateCountStatisticsSuccessAction,
  GetCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsActiveStandardCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsCanIssueVirtualCardsCountStatisticsSuccessAction,
  GetCreditCardsCountStatisticsSuccessAction,
  GetCreditCardsDelegateCountStatisticsSuccessAction,
  GetCreditCardsDelegateOwnerMeCountStatisticsSuccessAction,
  GetCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatisticsSuccessAction,
  GetCreditCardsPendingSourceUserMeCountStatisticsSuccessAction,
  GetCreditCardsPendingSourceUserOrViewerMeCountStatisticsSuccessAction,
  GetCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatisticsSuccessAction,
  GetCreditCardsSourceBudgetsEnabledCountStatisticsSuccessAction,
  GetCreditCardsSourceCountStatisticsSuccessAction,
  GetCreditCardsSourceUserOrViewerCountStatisticsSuccessAction,
  GetCreditCardsTimedOutSourceCountStatisticsSuccessAction,
  GetCreditCardsUserOrViewerMeCountStatisticsSuccessAction,
  GetGuestVirtualCardsRecipientMeCountStatisticsActions,
  GetVirtualCardsActiveOrPendingRecipientMeCountStatisticsSuccessAction,
  GetVirtualCardsActiveRecipientMeCountStatisticsSuccessAction,
  GetVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsSuccessAction,
  GetVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsSuccessAction,
  GetVirtualCardsCardholderPendingRequestOrApproverRuleApprovalMeCountStatisticsSuccessAction,
  GetVirtualCardsInactiveRecipientMeIssuedCountStatisticsSuccessAction,
  GetVirtualCardsPendingRequestCardholderMeCountStatisticsSuccessAction,
  GetVirtualCardsRecipientMeCountStatisticsSuccessAction,
} from 'src/queries/statistics/statistics.actions'

export type StatisticsState = typeof initialState

// roughly: object type first
// for credit cards, status:type:user:features:permission
// for virtual cards, status:user:permissions
export const initialState = {
  creditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveCanIssueVirtualCardsCount: 0,
  creditCardsActiveDirectEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveStandardCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceStandardCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount: 0,
  creditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCount: 0,
  virtualCardsActiveSourceUserOrViewerOrDelegateUserMeCount: 0,
  virtualCardsCardholderOrViewerMeActiveAndInactiveCount: 0,
  billPayCardsActiveSourceUserOrViewerOrDelegateUserMeCount: 0,
  billPayCardsCardholderOrViewerMeActiveAndInactiveCount: 0,
  billPayCardsPendingRequestsCount: 0,
  creditCardsCanIssueVirtualCardsCount: 0,
  creditCardsSourceBudgetsEnabledCanIssueBudgetsCount: 0,
  creditCardsSourceBudgetsEnabledCount: 0,
  creditCardsUserOrViewerMeCount: 0,
  virtualCardsPendingRequestCardholderMeCount: 0,
  virtualCardsCardholderPendingRequestOrApproverRuleApprovalCount: 0,
  creditCardsPendingSourceUserOrViewerMeCount: 0,
  creditCardsPendingSourceUserMeCount: 0,
  virtualCardsRecipientMeCount: 0,
  guestVirtualCardsRecipientMeCount: 0,
  virtualCardsInactiveRecipientMeIssuedCount: 0,
  virtualCardsActiveOrPendingRecipientMeCount: 0,
  virtualCardsActiveRecipientMeCount: 0,
  creditCardsActiveDelegateCount: 0,
  creditCardsActiveSourceCount: 0,
  creditCardsTimedOutSourceCount: 0,
  creditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCount: 0,
  creditCardsDelegateCount: 0,
  creditCardsDelegateOwnerMeCount: 0,
  creditCardsDelegateUserMeCount: 0,
  creditCardsSourceCount: 0,
  creditCardsSourceUserOrViewerCount: 0,
  creditCardsCount: 0,
}

export type Actions =
  | GetCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveStandardCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatisticsSuccessAction
  | GetVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsSuccessAction
  | GetVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsSuccessAction
  | GetBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatisticsSuccessAction
  | GetBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatisticsSuccessAction
  | GetBillPayCardsPendingRequestsCountStatisticsSuccessAction
  | GetCreditCardsCanIssueVirtualCardsCountStatisticsSuccessAction
  | GetCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatisticsSuccessAction
  | GetCreditCardsSourceBudgetsEnabledCountStatisticsSuccessAction
  | GetCreditCardsUserOrViewerMeCountStatisticsSuccessAction
  | GetVirtualCardsPendingRequestCardholderMeCountStatisticsSuccessAction
  | GetCreditCardsPendingSourceUserOrViewerMeCountStatisticsSuccessAction
  | GetCreditCardsPendingSourceUserMeCountStatisticsSuccessAction
  | GetVirtualCardsRecipientMeCountStatisticsSuccessAction
  | GetVirtualCardsInactiveRecipientMeIssuedCountStatisticsSuccessAction
  | GetVirtualCardsActiveOrPendingRecipientMeCountStatisticsSuccessAction
  | GetVirtualCardsCardholderPendingRequestOrApproverRuleApprovalMeCountStatisticsSuccessAction
  | GetVirtualCardsActiveRecipientMeCountStatisticsSuccessAction
  | GetCreditCardsActiveDelegateCountStatisticsSuccessAction
  | GetCreditCardsActiveSourceCountStatisticsSuccessAction
  | GetCreditCardsTimedOutSourceCountStatisticsSuccessAction
  | GetCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatisticsSuccessAction
  | GetCreditCardsDelegateCountStatisticsSuccessAction
  | GetCreditCardsDelegateOwnerMeCountStatisticsSuccessAction
  | GetBudgetsUserMeCountStatisticsSuccessAction
  | GetCreditCardsSourceCountStatisticsSuccessAction
  | GetCreditCardsSourceUserOrViewerCountStatisticsSuccessAction
  | GetCreditCardsCountStatisticsSuccessAction
  | GetGuestVirtualCardsRecipientMeCountStatisticsActions

const StatisticsReducer = (
  state: StatisticsState = initialState,
  action: Actions,
): StatisticsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_CREDIT_CARDS_ACTIVE_BALANCE_LOCK_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_DIRECT_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveDirectEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_RECURRENCE_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_BALANCE_LOCK_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_RECURRENCE_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_STANDARD_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveStandardCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_STANDARD_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceStandardCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_DIRECT_ENABLED_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_BUDGETS_ENABLED_CAN_ISSUE_BUDGETS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_ACTIVE_SOURCE_USER_OR_VIEWER_OR_DELEGATE_USER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsActiveSourceUserOrViewerOrDelegateUserMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_CARDHOLDER_OR_VIEWER_ME_ACTIVE_AND_INACTIVE_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsCardholderOrViewerMeActiveAndInactiveCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_BILL_PAY_CARDS_ACTIVE_SOURCE_USER_OR_VIEWER_OR_DELEGATE_USER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.billPayCardsActiveSourceUserOrViewerOrDelegateUserMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_BILL_PAY_CARDS_CARDHOLDER_OR_VIEWER_ME_ACTIVE_AND_INACTIVE_COUNT_STATISTICS_SUCCESS: {
        draft.billPayCardsCardholderOrViewerMeActiveAndInactiveCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_BILL_PAY_CARDS_PENDING_REQUESTS_COUNT_STATISTICS_SUCCESS: {
        draft.billPayCardsPendingRequestsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_CAN_ISSUE_VIRTUAL_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsCanIssueVirtualCardsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_SOURCE_BUDGETS_ENABLED_CAN_ISSUE_BUDGETS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsSourceBudgetsEnabledCanIssueBudgetsCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_SOURCE_BUDGETS_ENABLED_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsSourceBudgetsEnabledCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsUserOrViewerMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_PENDING_REQUEST_CARDHOLDER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsPendingRequestCardholderMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_CARDHOLDER_PENDING_REQUEST_OR_APPROVER_RULE_APPROVAL_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsCardholderPendingRequestOrApproverRuleApprovalCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_PENDING_SOURCE_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsPendingSourceUserOrViewerMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_PENDING_SOURCE_USER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsPendingSourceUserMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsRecipientMeCount = action.payload.statistics[0].value
        return draft
      }

      case GET_GUEST_VIRTUAL_CARDS_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS: {
        draft.guestVirtualCardsRecipientMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_INACTIVE_RECIPIENT_ME_ISSUED_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsInactiveRecipientMeIssuedCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_ACTIVE_OR_PENDING_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsActiveOrPendingRecipientMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_VIRTUAL_CARDS_ACTIVE_RECIPIENT_ME_COUNT_STATISTICS_SUCCESS: {
        draft.virtualCardsActiveRecipientMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_DELEGATE_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveDelegateCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_ACTIVE_SOURCE_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsActiveSourceCount = action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_TIMED_OUT_SOURCE_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsTimedOutSourceCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_PENDING_SOURCE_NEED_CARDHOLDER_VERIFICATION_USER_OR_VIEWER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_DELEGATE_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsDelegateCount = action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_DELEGATE_OWNER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsDelegateOwnerMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_BUDGETS_USER_ME_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsDelegateUserMeCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_SOURCE_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsSourceCount = action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_SOURCE_USER_OR_VIEWER_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsSourceUserOrViewerCount =
          action.payload.statistics[0].value
        return draft
      }

      case GET_CREDIT_CARDS_COUNT_STATISTICS_SUCCESS: {
        draft.creditCardsCount = action.payload.statistics[0].value
        return draft
      }
    }
  })
}

export default StatisticsReducer
